import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";
import { createURI } from "@/utils/string";

const service = {
    /**
     *
     * @returns {Promise<Array>}
     */
    async getAll({ systemType, brandId, zoneId, campaignId }) {
        console.assert(typeof systemType === "number");
        console.assert(typeof brandId === "number");
        console.assert(typeof zoneId === "number");
        console.assert(typeof campaignId === "number");
        const favorites = await http.get(buildUrlFromLocation(createURI("/favorites", { query: { systemType } }), { brandId, zoneId, campaignId }));
        return favorites.data;
    },
    async renameAt(id, { brandId, zoneId, campaignId, name }) {
        console.assert(typeof brandId === "number", "Invalid favorite brand Id");
        console.assert(typeof zoneId === "number", "Invalid favorite zone Id");
        console.assert(typeof campaignId === "number", "Invalid favorite campaign Id");
        console.assert(typeof id === "number", "Invalid favorite id");
        console.assert(typeof name === "string", "Invalid favorite name");
        return await http.put(buildUrlFromLocation(`/favorites/${id}`, { brandId, zoneId, campaignId }), { name });
    },
    async saveAt({ systemTypeId, brandId, zoneId, campaignId, content }) {
        console.assert(typeof systemTypeId === "number");
        console.assert(typeof brandId === "number");
        console.assert(typeof zoneId === "number");
        console.assert(typeof campaignId === "number");
        console.assert(typeof content === "object");
        return await http.post(buildUrlFromLocation("/favorites", { brandId, zoneId, campaignId }), {
            systemTypeId,
            content
        });
    },
    async removeAt(favoriteId) {
        console.assert(typeof favoriteId === "number");
        return await http.delete(buildUrlFromLocation(`/favorites/${favoriteId}`));
    }
};

export default service;



// WEBPACK FOOTER //
// ./src/services/favorites.js